import selectView from '../../components/select-view/select-view.vue'
export default {
    name: 'classsearch',
    data() {
        return {
            lableDom: '',
            searchResult: '搜索结果',
            // bread: '',
            allText: '全部',
            //一级菜单的面包屑
            firstBread: {},
            //二级菜单的面包屑
            secondBread: {},
            //三级菜单的面包屑
            thirdBread: {},
            // isApprove: false,
            // 判断是否需要展示判定年度
            isApprove: false,
            //三个筛选条件
            //选修必修
            attr: '',
            //认定非认定
            is_auth: '',
            //年度
            cer_year: '',
            //产品数组
            products: [],
            //页面总数
            pageTotal: 0,
            // 现在的页面偏移量
            pageCurrent: 0,
            //请求的课程数目
            pageClassNum: 10,
            //现在的标签id
            nowLabelId: null,
            //区分是通过search接口搜索课程还是通过标签来获取课程,trur是搜索
            isAll: false,
            //用来存储多级标签
            labels: {
                id: '0'
            },
			// 搜索字段
			name:'',
			// 标签数组
            sections:[],
            // 年份数组
            yearList: [],
            // 选择的年份
            year: '',
            // 课程包数组
            categoryList: [],
            // 购买前的提示
            payTips: false,
        }
    },
	components:{ selectView },
    methods: {
        changeColor(index) {
            // 这一段负责改变对应必修课/选修课文字颜色
            for (let i in this.$refs) {
                if (i.indexOf('lesson') >= 0) {
                    this.$refs[i].style.color = "";
                }
            }
            if (index == 3) {
                this.$refs['lesson0'].style.color = "";
                this.$refs['lesson1'].style.color = "";
            } else {
                this.$refs['lesson' + index].style.color = "#1E87F0";
            }
            index == 0 ? this.attr = '专业课' : this.attr = '选修课';
            if (this.isAll) {
                this.searchClass();
            } else {
                this.getresources(this.nowLabelId);
            }

        },
        change(index) {
            //改成认证/非认证文字颜色
            if (index == 0) {
                this.isApprove = true;
                this.is_auth = 1;
            } else if (index == 1) {
                this.isApprove = false;
                this.is_auth = 0;
                this.cer_year = '';
                this.$refs.year1.style.color = '';
                this.$refs.year2.style.color = '';
                this.$refs.year3.style.color = '';
            }
            for (let i in this.$refs) {
                if (i.indexOf('attribute') >= 0) {
                    this.$refs[i].style.color = "";
                }
            }
            this.$refs['attribute' + index].style.color = "#1E87F0";
            if (this.isAll) {
                this.searchClass();
            } else {
                this.getresources(this.nowLabelId);
            }

        },
        ch(index) {
            for (let i in this.$refs) {
                if (i.indexOf('year') >= 0) {
                    this.$refs[i].style.color = "";
                }
            }
            this.$refs['year' + index].style.color = "#1E87F0";
            if (index == 0) {
                this.cer_year = '2017';
            } else if (index == 1) {
                this.cer_year = '2018';
            } else if (index == 2) {
                this.cer_year = '2019';
            } else if (index == 3) {
                this.cer_year = '';
            }
            if (this.isAll) {
                this.searchClass();
            } else {
                this.getresources(this.nowLabelId);
            }
        },

        //点击课程跳转学习或详情
        classDetail: function (id, is_project, search_id) {
            let class_id = '';
            //search查出来的是id，标签拿出来的product_id
            String(id) != 'undefined' && String(id) != 'null' && String(id) != '' ? class_id = id : class_id = search_id;
            this.$toClass(class_id, is_project);
        },
        //点击顶部标签展示相应数据和去除相应标签颜色
        getTopLabeslData: function (id, index) {
            //偏移量变回0
            this.pageCurrent = 0;
            //判断点的是一级标签，清除相应数据的颜色
            if (index == 1) {
                this.secondBread = {};
                this.thirdBread = {};
                for (let val of this.labels.children) {
                    val.color = false;
                    if (val.children) {
                        for (let v of val.children) {
                            v.color = false;
                        }
                    }

                }
                //判断点的是二级标签，清除相应数据的颜色
            } else if (index == 2) {
                this.thirdBread = {};
                for (let val in this.labels.children) {
                    if (val.children) {
                        for (let v of val.children) {
                            v.color = false;
                        }
                    }

                }
            }
            //清楚颜色后再发起相应请求获取课程数据
            this.clearLabelColor();
            this.getresources(id)

        },
        //点击标签相应的类别显示
        relationClick: function (secondId, secondName, thirdId, thirdName) {
            //偏移量变回0
            this.pageCurrent = 0;
            //清楚文字颜色和标签筛选
            this.clearLabelColor();
            //判断是否三级标签
            if (thirdId) {
                for (let val of this.labels.children) {
                    val.color = false;
                    for (let v of val.children) {
                        if (v.id == thirdId) {
                            v.color = true;
                            val.color = true;
                        } else {
                            v.color = false;
                        }
                    }
                }
                this.getresources(thirdId);
                //一级面包屑
                this.firstBread.id = this.labels.id;
                this.firstBread.text = ` > ${this.labels.name}`;
                //二级面包屑
                this.secondBread.id = secondId;
                this.secondBread.text = ` > ${secondName}`;
                //三级面包屑
                this.thirdBread.id = thirdId;
                this.thirdBread.text = ` > ${thirdName}`;
                //判断是否二级标签
            } else if (secondId) {
                for (let val of this.labels.children) {
                    if (val.id == secondId) {
                        val.color = true;
                    } else {
                        val.color = false;
                    }
                }
                this.getresources(secondId);


                // console.log(this.labels.id);
                //是全部标签得情况
                if (this.labels.id == 0) {
                    this.firstBread.text = ` > 全部`;
                } else {
                    //一级面包屑
                    this.firstBread.id = this.labels.id;
                    this.firstBread.text = ` > ${this.labels.name}`;
                }
                //二级面包屑
                this.secondBread.id = secondId;
                this.secondBread.text = ` > ${secondName}`;
                //三级面包屑
                this.thirdBread = {};
            }
        },
        //清楚标签的颜色和标签数据
        clearLabelColor: function () {
            this.$refs.lesson0.style.color = '';
            this.$refs.lesson1.style.color = '';
            if (this.$refs.attribute0) {
                this.$refs.attribute0.style.color = '';
            }
            if (this.$refs.attribute1) {
                this.$refs.attribute1.style.color = '';
            }
            // this.$refs.attribute0.style.color = '';
            // this.$refs.attribute1.style.color = '';
            if (this.$refs.year1) {
                this.$refs.year1.style.color = '';
                this.$refs.year2.style.color = '';
                this.$refs.year3.style.color = '';
            }

            this.attr = '';
            this.cer_year = '';
            this.is_auth = '';
            if (this.$store.state.store.is_auth == '1') {
                this.isApprove = false
            }

        },
        //跳转回首页
        goIndex: function () {

        },
        //获取课程搜索类别标签
        getLabels: function () {
        },
        //获取相应的课程
        getresources: function (labelId) {
            this.nowLabelId = labelId;
            let data = {};
            if (labelId == 0) {
                data = {
                    offset: this.pageCurrent,
                    length: this.pageClassNum,
                    is_auth: this.is_auth,
                    attr: this.attr,
                    cer_year: this.cer_year
                };
            } else {
                data = {
                    offset: this.pageCurrent,
                    length: this.pageClassNum,
                    label_id: labelId,
                    is_auth: this.is_auth,
                    attr: this.attr,
                    cer_year: this.cer_year,
                    onsale: '1'
                };
            }
            this.$getStoreId().then(id => {
                //请求加上店铺id
                data.shop_id = id;
                this.$post('product_labels/listProducts', data).then(res => {
                    this.pageTotal = res.data.result.total;
                    this.products = res.data.result.data;
                })
            })

        },
        //分页后=>获取当前的数据
        currentPageData(index) {
            this.pageCurrent = (Number.parseInt(index) - 1) * this.pageClassNum;
            if (this.isAll) {
                this.searchClass();
            } else {
                this.getresources(this.nowLabelId);
            }

        },
        //当展示全部数据时候，根据页数来获取数据
        allCurrentPageData(offset) {

        },

        //根据传过来的标签分别请求数据
        accordingToLabelType() {
            // console.log(this.$route.query)

            switch (this.$route.query.lableType) {
                case "firstLable":
                    this.getresources(this.$route.query.firstId);
                    break;
                case "secondLable":
                    this.getresources(this.$route.query.secondId);
                    break;
                case "thirdLable":
                    this.getresources(this.$route.query.thirdId);
                    break;
                case "zeroLable":
                    //把0作为特殊标签，代表请求全部
                    this.getresources(this.$route.query.zeroId);
                    break;
                default:
            }
        },
        //获取所有标签
        getAllLabel() {
            this.$post('labels/all', { shop_id: this.$store.state.store.id }).then(res => {
                let data = res.data.result;
                //调用方法把标签的零级一级二级三级关系拼装
                this.allLabel(data, this.labels);
                return true;
            }).then(() => {

                if (this.$route.query.zeroId == 0) {
                    //用来临时装所有二级标签
                    let arr = [];
                    for (let val of this.labels.children) {
                        if (val.children) {
                            for (let v of val.children) {
                                //把所有二级标签都push进去arr临时数组
                                arr.push(v);
                            }
                        }
                    }
                    //再把arr二级标签（二级里面包含三级）赋值给回labels数组（用来装标签得）
                    this.labels.children = arr;
                    //把所有二级三级标签得颜色标识变成无
                    for (let val of this.labels.children) {
                        val.color = false;
                        if (val.children) {
                            for (let v of val.children) {
                                v.color = false;
                            }
                        }
                    }
                } else {
                    //把标签的树状结构拼成对应的一级二级三级结构，0级去掉
                    for (let val of this.labels.children) {
                        if (val.id == this.$route.query.firstId) {
                            this.labels = val;
                        }
                    }
                    //根据去掉了0级的树状结构给一个辨别文字是否点亮的标识=>color
                    for (let val of this.labels.children) {
                        this.$route.query.secondId && this.$route.query.secondId == val.id ? val.color = true : val.color = false;
                        if (val.children) {
                            for (let v of val.children) {
                                this.$route.query.thirdId && this.$route.query.thirdId == v.id ? v.color = true : v.color = false;
                            }
                        }
                    }
                }

                //根据传来的id来获取顶部的面包屑
                switch (this.$route.query.lableType) {
                    case "firstLable":
                        //一级面包屑
                        this.firstBread.id = this.labels.id;
                        this.firstBread.text = ` > ${this.labels.name}`;
                        break;
                    case "secondLable":
                        //一级面包屑
                        this.firstBread.id = this.labels.id;
                        this.firstBread.text = ` > ${this.labels.name}`;
                        for (let val of this.labels.children) {
                            if (val.id == this.$route.query.secondId) {
                                //二级面包屑
                                this.secondBread.id = val.id;
                                this.secondBread.text = ` > ${val.name}`;
                            }
                        }
                        break;
                    case "thirdLable":
                        //一级面包屑
                        this.firstBread.id = this.labels.id;
                        this.firstBread.text = ` > ${this.labels.name}`;
                        for (let val of this.labels.children) {
                            if (val.id == this.$route.query.secondId) {
                                //二级面包屑
                                this.secondBread.id = val.id;
                                this.secondBread.text = ` > ${val.name}`;
                            }
                            if (val.children) {
                                //三级面包屑
                                for (let v of val.children) {
                                    if (v.id == this.$route.query.thirdId) {
                                        this.thirdBread.id = v.id;
                                        this.thirdBread.text = ` > ${v.name}`;
                                    }

                                }
                            }
                        }
                        break;
                    case "zeroLable":
                        //一级面包屑
                        this.firstBread.text = ` > 全部课程`;
                        break;
                    default:
                }
            })
        },
        //递归拼装所有标签
        allLabel(data, labelObj) {
            for (let i in data) {
                if (data[i].parent_id === labelObj.id) {
                    if (!labelObj.children) {
                        labelObj.children = [];
                    }
                    labelObj.children.push(data[i]);
                    this.allLabel(data, data[i]);
                }
            }
        },
        //根据产品名字搜索课程
        searchClass() {
            //把标识改成true，代表产品是通过课程搜索出来的
            this.isAll = true;
            this.$getStoreId().then(id => {
                let data = {
                    category_name: this.name == '' ? this.$route.query.data : this.name,
                    is_auth: this.is_auth,
                    attr: this.attr,
                    year: this.year,
                    shop_id: id,
                    offset: this.pageCurrent,
                    length: this.pageClassNum,
                    available: 1,
					name:this.name
                }
                this.$post('product_category/search_products', data).then(res => {
                    this.products = res.data.result.data;
                    this.pageTotal = res.data.result.total;
                    // console.log(this.products);
                })
            })

        },
		// 获取年份标签
		getLaber(){
			this.$post('product_category/get_year', {
				available: 1,
				offset: 0,
				length: 999
			}).then(res => {
                // 获取排序后的年份数组
                this.yearList = (res.data.result.data.map(item => item.year)).sort((a, b) => b * 1 - a * 1);
                console.log('this.yearList', this.yearList);

				let yearArr = res.data.result.data
				let allProducts = []
				this.$post('product_category/search_products', {
					shop_id: id,
					available: 1,
					offset: 0,
					length: 5,
					year: yearArr[0].year
				}).then(res => {
					this.sections = yearArr
					this.sections[0].products = res.data.result.data
					this.sections[0].total = res.data.result.total
					console.log(this.sections,'1')
				})
			})
        },
        // 获取所有课程包
        getAllCategory() {
            this.$post('product_category/search', {
                offset: 0,
                length: 9999,
                shop_id: this.$store.state.store.id,
                available: 1
            }).then(res => {
                this.categoryList = res.data.result.data.map(item => item.name);
            })
        }
    },
    created: function () {
		this.getLaber()	
        this.searchClass();
        // this.getAllCategory();
        // console.log(this.$store.state.store.is_auth);
        this.$store.state.store.is_auth == '0' ? this.isApprove = true : this.isApprove;
        if (this.$route.query.value == 'classtext') {
            
        } else {
            this.accordingToLabelType();
            // this.getAllLabel()
        }

    },
    mounted: function () {
        document.title = '课程列表';
        // this.changeSearchResult();
        this.lableDom = document.getElementsByClassName('navBtn-li')[0];
        // 跳转此页面全部这两个字变色
        if (this.$route.query.firstName == '全部') {
            this.changeAllColor();
        }
        
        if(this.$store.state.store.id == 107){
            this.payTips = true
        }
    }

}

